import z from 'zod';

import { LANGUAGES } from '@/constants/languages';
import { useUserStore } from '@/store/userStore';

const langParameterSchema = z.literal(LANGUAGES).default('en');

export function setLanguageFromUrl(request: Request): void {
  const { userProvider } = useUserStore.getState();
  const url = new URL(request.url);

  const { data: language } = z.safeParse(langParameterSchema, url.searchParams.get('lang'));

  if (language) {
    userProvider.language = language;
  }
}
